import React, { useEffect, useState } from 'react'
import { RefActiveParticipantsWithAllPlacements, refreshAllDatasets } from '../hooks/DatasetHooks'
import * as libCon from "../community-hats-js-library/Constants.js"
import { Button, Card, Input, Space, Spin } from "antd";
import { Typography } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone, } from '@ant-design/icons';
import { formatDistance } from 'date-fns';
import { RefContextLanguage } from '../providers/LanguageProvider';

const { Title, Text } = Typography;

function DashboardDeploymentStatus() {


  const i18n = RefContextLanguage()

  // Participants
  const [status, participants] = RefActiveParticipantsWithAllPlacements()

  const [participantArray, setParticipantArray] = useState([])


  const [inputValue, setInputValue] = useState(() => null)
  const [filterText, setFilterText] = useState(() => null)

  useEffect(() => {

    if (participants !== null) {
      let parArray = Object.values(participants)
      if (filterText !== null && filterText !== undefined && filterText !== "")
        parArray = parArray.filter(ob => ob[libCon.ATF_PUBLIC_ID].toUpperCase().includes(filterText.toUpperCase()))

      parArray.sort((a, b) => new Date(b[libCon.ATF_JOINED_DATE]) - new Date(a[libCon.ATF_JOINED_DATE]));
      if (parArray.length > 0)
        parArray = parArray.slice(0, Math.min(10, parArray.length))

      setParticipantArray(parArray)
    }

  }, [participants, filterText])


  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };


  const DeploymentStatusCard = ({ participant }) => {

    const isCorrect = participant[libCon.ATF_HAS_ACTIVE_SENSORS] && participant[libCon.ATF_HAS_ACTIVE_WEARABLES] && participant[libCon.ATF_HAS_ACTIVE_PHONES]

    return (
      <Card style={{ marginTop: "2%", border: isCorrect ? "4px solid #63b06d" : "4px solid #b7362d" }}
        headStyle={{ backgroundColor: isCorrect ? "var(--success-color-1)" : "var(--warning-color-1)" }}
        title={participant[libCon.ATF_PUBLIC_ID]}>
        <div style={{ marginBottom: "15px", display: "flex", justifyContent: "space-around" }}>
          <Text strong>{i18n.t('sensors')}: {participant[libCon.ATF_HAS_ACTIVE_SENSORS] ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleTwoTone twoToneColor="#e91822" />} {`(${participant[libCon.ATF_TOTAL_ACTIVE_SENSORS]})`}</Text>
          <Text strong>{i18n.t('wearable')}: {participant[libCon.ATF_HAS_ACTIVE_WEARABLES] ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleTwoTone twoToneColor="#e91822" />}</Text>
          <Text strong>{i18n.t('phone')}: {participant[libCon.ATF_HAS_ACTIVE_PHONES] ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleTwoTone twoToneColor="#e91822" />}</Text>
        </div>
        <Card headStyle={{ backgroundColor: isCorrect ? "var(--success-color-1-transparent)" : "var(--warning-color-1-transparent)" }} type="inner" size="small" style={{ paddingtop: "0px" }} title={i18n.t('membershipNumber')}>
          {participant[libCon.ATF_SEWA_ID]}
        </Card>
        <Card headStyle={{ backgroundColor: isCorrect ? "var(--success-color-1-transparent)" : "var(--warning-color-1-transparent)" }} type="inner" size="small" title={i18n.t('name')}>
          {participant[libCon.ATF_NAME]}
        </Card>
        <Card headStyle={{ backgroundColor: isCorrect ? "var(--success-color-1-transparent)" : "var(--warning-color-1-transparent)" }} type="inner" size="small" title={i18n.t('lastName')}>
          {participant[libCon.ATF_LAST_NAME]}
        </Card>
        <Card headStyle={{ backgroundColor: isCorrect ? "var(--success-color-1-transparent)" : "var(--warning-color-1-transparent)" }} type="inner" size="small" title={i18n.t('recordAdded')}>
          {formatDistance(new Date(participant[libCon.ATF_JOINED_DATE]), new Date(), { addSuffix: true })}
        </Card>

      </Card>
    )
  }

  return (
    <div className="mainContainer">
      <Title level={2}>{i18n.t('participantsDeploymentStatus')}</Title>
      <Space direction="vertical" >
        <Space direction="horizontal" >
          <Button type="primary" onClick={() => refreshAllDatasets()}>{i18n.t('refresh')}</Button>
          <Input placeholder={i18n.t('filter')} value={inputValue} onChange={handleInputChange} />
          <Button type="primary" onClick={() => setFilterText(inputValue)}>{i18n.t('filter')}</Button>
          <Button type="primary" onClick={() => { setInputValue(null); setFilterText(null) }} danger>{i18n.t('clear')}</Button>
        </Space>

      </Space>

      <div style={{ marginTop: "5%" }}>
        {
          status === libCon.STATUS_NOT_STARTED || status === libCon.LOADING || participants === null
            ? <Spin />
            : status === libCon.ERROR
              ? <div>{i18n.t('error')}</div>
              : <div>
                {
                  participantArray.length > 0
                    ? participantArray.map(par => <DeploymentStatusCard key={par[libCon.ID]} participant={par} />)
                    : <Title level={3}>{i18n.t('noRecordsFound')}</Title>
                }
              </div>
        }
      </div>
    </div>
  )
}

export default DashboardDeploymentStatus